/// <reference types="bun-types" />
/// <reference lib="dom" />
/// <reference lib="dom.iterable" />

import { Dog } from "./components/Dog";

async function main() {
  // @ts-expect-error
  customElements.define("dog-", Dog);
}

window.addEventListener("load", main);
